import React from 'react';

const UBadge = (props) => {
    return (
        <React.Fragment>
            <p className="u_badge"><span className="u_badge-inner">{props.count}</span></p>
        </React.Fragment>
    );
};

export default UBadge;